module.exports = __webpack_public_path__ + "static/media/Abbie.81389c3c.jpg";